<template>
  <div>
    <!-- <Header class="coupon_header"/> -->
    <!-- <Login/> -->
    <main class="main coupon_main">
      <div class="receiveCoupon">
        <div class="bodyWrapper">
            <!-- <div class="loginfixed"><a href="#"><span>登入查看禮物序號與朋友留言</span></a></div>禮物如已被領取的話要隱藏 -->
            <header class="bodyHeader nav-down cf">
              <div class="wrapper">
                <div class="topSec">
                  <strong class="logo">
                    <img src="@/assets/images/logo.png" alt="一刻鯨選">
                  </strong>
                </div>
              </div>
            </header>
            <main class="main">

              <div class="bodyContent">
                <div class="container">
                  <section v-if="!isExchange" class="hdtopic">
                    <!--20200605改文案 -->
                    <p>您收到了一個禮物</p>
                  </section>

                  <div v-if="!isExchange">
                    <section class="couponinfo">
                      <div class="course" v-if="channel.author">
                        <figure>
                          <div class="graphic">
                            <img :src="channel.imgCover" class="img-fluid" :alt="channel.title">
                          </div>
                        </figure>
                        <figcaption>
                          <h3>{{ channel.title }}</h3>
                          <p>{{ channel.author.title }}</p>
                        </figcaption>
                      </div>

                      <div class="sec_1">
                        <!--20200605移除 <p class="subinfo mobileweb">從App中領取此主題</p> -->
                        <a class="btnStyle_2 fullWidth mobileweb" :href="couponQRCode">開啟App領取</a>

                        <p class="subinfo pcweb">
                          您可以複製序號，在一刻鯨選官網存入禮物
                        </p>

                        <div class="serialnumber pcweb">
                          <div id="serial_pcweb">{{ number }}</div>
                          <div class="btn_copy clipboard" id="copyBtn_pcweb"
                          name="serial" data-clipboard-target="#serial_pcweb">複製</div>
                        </div>

                        <router-link to="/member/coupon" class="btnStyle_2 fullWidth pcweb">前往官網存入</router-link>
                      </div>

                      <hr class="dividedline">

                      <div class="sec_2">
                        <!--20200605改文案-->
                        <p class="subinfo mobileweb">或複製序號後前往官網兌換領取</p>
                        <div class="serialnumber mobileweb">
                          <div id="serial">{{ number }}</div>
                          <div class="btn_copy clipboard"  data-clipboard-target="#serial">複製</div>
                        </div>

                        <!--20200605新增按鈕-->
                        <a class="btnStyle_2 color1light_2 fullWidth mobileweb" href="/member/coupon">前往官網存入 </a>

                        <!--20200605修改文案 您也可以前往<b>一刻鯨選App</b>了解更多 -->
                        <p class="subinfo pcweb">您也可以前往一刻鯨選App直接領取</p>
                        <div class="qrcode pcweb">
                          <qrcode-vue :value="couponQRCode" :size="125" level="H" class="qrcode_img"></qrcode-vue>
                        </div>
                      </div>

                      <!-- 訊息toast --><!-- <div id="msg"></div> -->

                    </section>
                    <!-- <div class="loginfixed"
                    v-if="userInfo.id == null">
                        <a href="javascript::"
                        class="openLogin">
                            <span>登入查看禮物序號與朋友留言</span>
                        </a>
                    </div> -->

                    <!-- 禮物如已被領取的話要隱藏 -->
                    <section class="flexcenter">
                      <p class="enddate">
                        有效期限至 {{convertUTCTimeToLocalTime(coupon_end)}}
                      </p>
                    </section>

                    <section class="message">
                      <div class="bubble">
                        <!-- <p>{{ gift_customer.message }} — from {{ gift_customer.nickname }}</p> -->
                        <!--20200605新增--><strong>贈送者給你的留言：</strong>
                        <p>{{ gift_customer.message }} <span v-if="gift_customer.nickname != '' && gift_customer.nickname !== null">— from</span> {{ gift_customer.nickname }}</p>
                      </div>
                    </section>
                  </div>
                  <div v-if="isExchange">
                    <section class="couponinfo">
                      <div class="course" v-if="channel.author">
                        <figure>
                          <div class="graphic"><img :src="channel.imgCover" class="img-fluid" :alt="channel.title"></div>
                        </figure>
                        <figcaption>
                          <h3>{{ channel.title }}</h3>
                          <p>{{ channel.author.title }}</p>
                        </figcaption>
                      </div>

                      <div class="gift_received">
                        <div class="wrap">
                          <figure>
                            <div class="graphic"><img src="@/assets/images/status_empty_gift.png" alt="禮物已被領取完畢"></div>
                            <figcaption>
                                <!--20200605改文案 --><h4>慢了一步，禮品券已被領取</h4>
                                <!--20200605移除 <p class="mobileweb">您也可以到App中瀏覽此門主題的內容</p>
                                <p class="pcweb">您也可以到官網瀏覽此門主題的內容</p> -->
                            </figcaption>
                          </figure>
                          <a
                              class="btnStyle_2 fullWidth mobileweb"
                              :href="courseQRCode">
                              <!--20200605改文案-->
                              瀏覽此門主題
                          </a>
                          <router-link
                            :to="'/channel/'+channel.id"
                            class="btnStyle_2 fullWidth pcweb"
                            >瀏覽此門主題
                          </router-link>
                        </div>
                      </div>

                      <hr class="dividedline pcweb">

                      <div class="sec_2">
                        <p class="subinfo pcweb">您也可以前往<b>一刻鯨選App</b>了解更多</p>
                        <div class="qrcode pcweb">
                          <qrcode-vue :value="courseQRCode" :size="125" level="H" class="qrcode_img"></qrcode-vue>
                          <!-- 此qrcode是課程，菲禮物的 -->
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>

            </main>

            <footer>
              <div class="container">

                <div class="">
                  <div class="row">
                    <div class="appIcon">
                      <img src="@/assets/images/appicon.png" alt="一刻鯨選">
                    </div>
                    <div class="stores">
                      <a href="https://apps.apple.com/tw/app/%E4%B8%80%E5%88%BB%E9%AF%A8%E9%81%B8/id1440248584"><img src="@/assets/images/appstore.png" title="從 App Store 下載"></a>

                      <a href="https://play.google.com/store/apps/details?id=net.jinfm.app&hl=zh_TW"><img src="@/assets/images/googleplay.png" title="從 Google Play 下載"></a>
                    </div>
                  </div>
                  <p class="copyR">聯合報系 著作權所有 © udngroup.com. All Rights Reserved.</p>
                </div>

              </div>
            </footer>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import QrcodeVue from 'qrcode.vue'
import { mapGetters } from 'vuex'
// import Cookies from 'js-cookie'
// import Login from "../views/Login";

// 一鍵複製
$(document).ready(function () {
  var clipboard = new Clipboard('.clipboard')

  clipboard.on('success', function (e) {
    $(e.trigger).text('複製成功！')
    e.clearSelection()
    setTimeout(function () {
      $(e.trigger).text('複製')
    }, 2500)
  })

  // clipboard.on('error', function(e) {
  //   $(e.trigger).text("複製失敗");
  //   setTimeout(function() {
  //     $(e.trigger).text("複製");
  //   }, 2500);
  // });
})

export default {
  name: 'gift',
  metaInfo () {
    return {

      title: '禮物卡 | 一刻鯨選',
      meta: [
        // OpenGraph data (Most widely used)
        { property: 'og:title', content: '禮物卡 | 一刻鯨選' },
        { property: 'og:site_name', content: '禮物卡 | 一刻鯨選' },
        // The list of types is available here: http://ogp.me/#types
        { property: 'og:type', content: 'website' },
        // Should the the same as your canonical link, see below.
        { property: 'og:url', content: window.location.toString() },
        { property: 'og:image', content: this.$store.state.urlDomain + '/static/logo.jpg' },
        // Often the same as your meta description, but not always.
        { property: 'og:description', content: '一刻鯨選，行動新課堂，15分鐘聆聽新知，深入淺出，充實每一刻！打破學習框架，隨選隨聽，商管投資、文史賞析、生活陶冶，療癒心靈、充實大腦，浩瀚知識洋，即刻探索！' }

      ]
    }
  },
  components: {
    QrcodeVue
    // Login
  },
  data () {
    return {
      gift_customer: {
        nickname: '',
        message: '我贈送了一門課程給你，希望你會喜歡！ :)'
      },
      channel: {},
      coupon_end: '',
      isExchange: false,
      number: '',
      couponQRCode: '',
      courseQRCode: ''
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'isAuthenticated',
      'baseURL',
      'urlHost'
    ])
  },
  methods: {
    convertUTCTimeToLocalTime: function (UTCDateString) {
      if (!UTCDateString) {
        return '-'
      }
      function formatFunc (str) {
        return str > 9 ? str : `0${str}`
      }
      var date2 = new Date(UTCDateString)
      var year = date2.getFullYear()
      var mon = formatFunc(date2.getMonth() + 1)
      var day = formatFunc(date2.getDate())
      // var hour = formatFunc(date2.getHours());
      // var min = formatFunc(date2.getMinutes());
      var dateStr = `${year}/${mon}/${day}`
      return dateStr
    }
  },
  created () {
    const vm = this
    vm.number = vm.$route.params.id

    vm.$http.get(`${vm.baseURL}coupons/${vm.number}`)
      .then((response) => {
        // console.log(response);
        // eslint-disable-next-line eqeqeq
        if (response.status == 200) {
          vm.channel = response.data.channel
          vm.coupon_end = response.data.coupon_end
          vm.gift_customer.nickname = response.data.gift_customer.nickname
          vm.gift_customer.message = response.data.gift_customer.message
          vm.isExchange = response.data.isExchange
          // vm.number = response.data.number
          // Cookies.set("coupon", vm.number);
          vm.couponQRCode = `https://jinfm.page.link/?link=${vm.urlHost}/coupon/${vm.number}&apn=net.jinfm.app&isi=1440248584&ibi=net.jinfm.app&ius=jinfm`
          vm.courseQRCode = `https://jinfm.page.link/?link=${vm.urlHost}/channel/${vm.channel.id}&apn=net.jinfm.app&isi=1440248584&ibi=net.jinfm.app&ius=jinfm`
        } else if (response.includes('404')) {
          this.$router.push('/')
        }
      }).catch(error => console.log('log:' + error))
  },
  mounted () {
    // 登入Light Box
    $('.openLogin').click(function () {
      $('.login').fadeIn(200).css('display', 'flex')
      $('body').addClass('overflowhidden')
      $('.bodyHeader').addClass('bodyHeader_hidden')
      return false
    })
  }
}
</script>

<style scoped>
  @media screen and (min-width: 768px){
    .coupon_main {
        margin-top: -128px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Gift.vue